import React from 'react';
import { Divider, Stack, Typography } from "@mui/material";

const FormSectionHeader = ({ title, description }) => {
    return (
        <Stack spacing={0} sx={{
            width: "100%", justifyContent: "flex-start",
            alignItems: "flex-start"
        }} role="region" aria-label={`${title} Section`}>
            <Typography variant='h5'>{title}</Typography>
            <Divider flexItem />
            {description && <Typography variant='body1' >{description}</Typography>}
            
        </Stack>
    )
}

export default FormSectionHeader;
